// Entrée de l'application : Tailwind, police Inter, Turbo et Stimulus
// (garde : javascript_source_guard_test).
import '@fontsource-variable/inter'
import '../stylesheets/application.css'

import * as Turbo from "@hotwired/turbo"
import { confirmDialog } from '../js/confirm_dialog'
Turbo.config.forms.mode = "on"
Turbo.config.forms.confirm = confirmDialog // confirmations data-turbo-confirm : <dialog> natif

import '../js/frame_missing' // Frame absente de la réponse : page entière
import '../js/page_focus' // visite Turbo : focus sur le contenu de la nouvelle page

import '../controllers'
